<template>
    <div style="display:flex">
      <router-link :to="{ name: 'Login' }" type="button" class="button secondary">Giriş Yap</router-link>
      <router-link :to="{ name: 'Register' }" type="button" class="button primary">Kayıt Ol</router-link>
    </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import SocialMedia from '../SocialMedia'
  import Register from '../../../views/Auth/Register'

  export default{
    name: "DesktopGuest",
    data(){
      return{
        //is_login_error: false,
        registerModal: false,
        form:{
          username: null,
          password: null,
        }
      }
    },
    computed:{
      ...mapState("auth", ["isLoading"])
    },
    methods:{
      ...mapActions("auth", ["login"]),

      handleLogin() {
        this.login(this.form);
      }
    },
    components:{
      SocialMedia,
      Register
    },
    watch:{
      /*is_login_error(val){
        if(val){
          setTimeout(() => {
            this.is_login_error = false;
          },3000);
        }
      }*/
    }
  }
  
</script>